import script from "./EditItemsForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EditItemsForm.vue?vue&type=script&setup=true&lang=js"

import "./EditItemsForm.vue?vue&type=style&index=0&id=1c34f47e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c34f47e"]])

export default __exports__